module.exports = __webpack_public_path__ + "img/icon-gp-128x128-04-ribbon.15e5089a.svg";